import Model from "../../Lib/Model";
import Color from "../../Lib/Color";


export default class Swatch extends Model {

    getColor() {
        return Color.fromRGB(this.color);
    }

}
